import { Loading } from '@/components/ui/loading';
import { selectSession, selectSessionUser } from '@/lib/frontend/store/helpers';
import { useAppSelector } from '@/lib/frontend/store/hooks';
import React, { PropsWithChildren } from 'react';
import SessionInitFailed from './SessionInitFailed';

type Props = PropsWithChildren<{
  loggedOutContent?: React.ReactNode;
}>;

export const SessionWrapper = (props: Props) => {
  const session = useAppSelector(selectSession);
  const user = useAppSelector(selectSessionUser);

  // Show loading state while session is initializing
  if (!session.initialized) {
    return <Loading />;
  }

  // Show error if session initialization failed
  if (session.initializationFailed) {
    return <SessionInitFailed error={session.initializationFailedError} />;
  }

  // Render logged out content if no user is signed in
  if (!user && props.loggedOutContent) {
    return props.loggedOutContent;
  }

  return props.children;
};
